import { render } from "./HeroiconsOutlineBackspace.vue?vue&type=template&id=6310063c"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBackspace.vue"]])

export default __exports__